import { useColorMode } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { setZone } from '@/libs/dayjs'
import i18n from '@/libs/i18n'
import type { IPublicTenant } from '@/types/Public'

export const useAppStore = defineStore('app', () => {
    const locale       = ref(String(i18n.global.locale.value))
    const loaderActive = ref(0)

    /** The business whose page this is, once GET /{slug} has answered. */
    const tenant = ref<IPublicTenant | null>(null)

    // Wraps the SAME state @nuxt/ui's vue plugin already manages via useDark().
    const colorMode = useColorMode({ storageKey: 'vueuse-color-scheme' })

    const setTenant = (value: IPublicTenant | null) => {
        tenant.value = value
        setZone(value?.timezone)
    }

    const startLoading = () => loaderActive.value++
    const stopLoading  = () => loaderActive.value = Math.max(0, loaderActive.value - 1)

    const changeLocale = (newLocale: string) => {
        locale.value = newLocale
        localStorage.setItem('locale', newLocale)
        ;(i18n.global.locale as unknown as { value: string }).value = newLocale
        document.documentElement.lang = newLocale
    }

    return { locale, loaderActive, tenant, colorMode, setTenant, startLoading, stopLoading, changeLocale }
})
